import { render } from "./mail-admin-modal.vue?vue&type=template&id=6ad3e4dd"
import script from "./mail-admin-modal.vue?vue&type=script&lang=js"
export * from "./mail-admin-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__